(function() {
  // MOBILE MENU
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".mobile-menu__item--has-items > .mobile-navlink").forEach(bt => {
      bt.addEventListener("click", (event) => {
        event.preventDefault();

        const li = event.target.closest('li');
        if (!li) return;

        const button = li.querySelector('.mobile-nav__trigger');
        if (!button) return;

        button.click();
      });
    });
  });

  // BEFORE / AFTER
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".before-after-wrapper").forEach(wrapper => {
      const afterWrapper = wrapper.querySelector(".after-image-wrapper");
      const handle = wrapper.querySelector(".slider-handle");
  
      const moveSlider = (x) => {
        const bounds = wrapper.getBoundingClientRect();
        let position = x - bounds.left;
        let percent = (position / bounds.width) * 100;
        percent = Math.max(5, Math.min(95, percent));
        //position = Math.max(0, Math.min(bounds.width, position));
        //const percent = (position / bounds.width) * 100;
        //afterWrapper.style.width = percent + "%";
        afterWrapper.style.setProperty('--percent', percent + '%');
        handle.style.left = percent + "%";
      };
  
      const startSlide = (e) => {
        const move = (event) => {
          const clientX = event.touches ? event.touches[0].clientX : event.clientX;
          moveSlider(clientX);
        };
        const stop = () => {
          window.removeEventListener("mousemove", move);
          window.removeEventListener("touchmove", move);
          window.removeEventListener("mouseup", stop);
          window.removeEventListener("touchend", stop);
        };
  
        window.addEventListener("mousemove", move);
        window.addEventListener("touchmove", move);
        window.addEventListener("mouseup", stop);
        window.addEventListener("touchend", stop);
      };
  
      handle.addEventListener("mousedown", startSlide);
      handle.addEventListener("touchstart", startSlide);
      wrapper.addEventListener("click", (e) => moveSlider(e.clientX));
    });
  });

  // CUSTOM SWATCHES VERNIS PRODUCTS
  document.addEventListener('DOMContentLoaded', async () => {
    const customSwatchesVernisContainer = document.getElementById('custom-swatches-vernis');
    if (!customSwatchesVernisContainer) return;

    const customSwatchesVernisCollectionId = customSwatchesVernisContainer.dataset.collection;

    const locale = window.Shopify.locale.toUpperCase();
    
    const query = `
      query collectionVernisSwatches @inContext(language: ${locale}) {
        collection(id: "gid://shopify/Collection/${customSwatchesVernisCollectionId}") {
          title
          products(first: 250) {
            edges {
              node {
                title
                handle
                metaColorLabel: metafield(namespace: "custom", key: "couleur_libelle") { value }
                metaColorHexa: metafield(namespace: "custom", key: "couleur_code_hexa") { value }
              }
            }
          }
        }
      }
    `;

    try {
      const response = await fetch(window.Shopify.routes.root + 'api/2024-10/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': '9ff8f07598c4c8766887953c66ec243e',
        },
        body: JSON.stringify({ query }),
      });

      const result = await response.json();
      const products = result.data.collection.products.edges.map(edge => edge.node);
      const currentHandle = window.location.pathname.split('/products/')[1]?.split('/')[0];

      const html = products.map(p => {
        const colorHex = p.metafield?.find(m => m.key === "couleur_code_hexa")?.value || p.metaColorHexa?.value || "#e5e5e5";
        const colorLabel = p.metafield?.find(m => m.key === "couleur_libelle")?.value || p.metaColorLabel?.value || '';
        const productUrl = `/products/${p.handle}`;
        const selectedClass = (p.handle === currentHandle ? ' selected' : '') + (isLightColor(colorHex, 225) ? ' light-color' : '');

        return `
          <span class="swatch__button swatch__button--circle">
            <a href="${productUrl}" class="swatch__label${selectedClass}" ${colorLabel ? `data-tooltip="${colorLabel}"` : ""} data-color="${colorHex}" style="--swatch: ${colorHex}">
              <span class="visually-hidden">${colorLabel}</span>
              <span class="icon icon-check"></span>
            </a>
          </span>
        `;
      }).join('');

      customSwatchesVernisContainer.innerHTML = html;

      const customSwatchesVernisToggle = document.getElementById('custom-swatches-vernis-toggle');
      const customSwatchesVernisToggleCount = customSwatchesVernisToggle.querySelector('span');
      customSwatchesVernisToggleCount.innerHTML = products.length;
      
      customSwatchesVernisToggle.addEventListener('click', () => {
        const collapsedHeight = '36px';
        const isExpanded = customSwatchesVernisContainer.classList.contains('expanded');

        if (isExpanded) {
          customSwatchesVernisContainer.style.maxHeight = collapsedHeight;
          customSwatchesVernisContainer.classList.remove('expanded');
        } else {
          const fullHeight = customSwatchesVernisContainer.scrollHeight + 'px';
          customSwatchesVernisContainer.style.maxHeight = fullHeight;
          customSwatchesVernisContainer.classList.add('expanded');

          customSwatchesVernisContainer.addEventListener('transitionend', function handler() {
            customSwatchesVernisContainer.style.maxHeight = 'none';
            customSwatchesVernisContainer.removeEventListener('transitionend', handler);
          });
        }
      });

      setTimeout(() => {
        const tooltippedEls = customSwatchesVernisContainer.querySelectorAll('[data-tooltip]');

        const cleanupAllTooltips = () => {
          document.querySelectorAll('.custom-tooltip').forEach(t => t.remove());
          tooltippedEls.forEach(el => el._tooltip = null);
        };

        ['scroll', 'resize'].forEach(evt => window.addEventListener(evt, cleanupAllTooltips));

        tooltippedEls.forEach(el => {
          el.addEventListener('mouseenter', () => {
            const text = el.getAttribute('data-tooltip');
            if (!text) return;

            cleanupAllTooltips();

            const tooltip = document.createElement('div');
            tooltip.className = 'custom-tooltip';
            tooltip.textContent = text;
            document.body.appendChild(tooltip);

            el._tooltip = tooltip;

            const rect = el.getBoundingClientRect();
            const top = rect.bottom + window.scrollY + 8;
            const left = rect.left + rect.width / 2 - tooltip.offsetWidth / 2;
            tooltip.style.top = `${top}px`;
            tooltip.style.left = `${left}px`;

            requestAnimationFrame(() => tooltip.classList.add('visible'));
          });

          el.addEventListener('mouseleave', () => {
            const tooltip = el._tooltip;
            if (tooltip) {
              tooltip.classList.remove('visible');
              tooltip.addEventListener('transitionend', () => {
                tooltip.remove();
                el._tooltip = null;
              }, { once: true });
            }
          });

          const observer = new MutationObserver(() => {
            if (!document.body.contains(el)) {
              if (el._tooltip) el._tooltip.remove();
              observer.disconnect();
            }
          });
          observer.observe(document.body, { childList: true, subtree: true });
        });
      }, 100);

      // Resize
      const swatchTotal = customSwatchesVernisContainer.querySelectorAll('.swatch__button').length;

      function checkSwatchesFit() {
        const swatchesPerRow = Math.floor(customSwatchesVernisContainer.clientWidth / (32 + 8));
        
        if (swatchesPerRow >= swatchTotal) customSwatchesVernisToggle.style.display = 'none';
        else customSwatchesVernisToggle.style.display = 'flex';
      }

      window.addEventListener('load', checkSwatchesFit);
      window.addEventListener('resize', () => {
        clearTimeout(window._swatchesResizeTimeout);
        window._swatchesResizeTimeout = setTimeout(checkSwatchesFit, 200);
      });

    } catch (err) {
      console.error('Erreur chargement swatches vernis :', err);
    }
  });

  // CUSTOM SWATCHES VERNIS COLLECTION
  document.addEventListener('DOMContentLoaded', async () => {
    const customSwatchesVernisElements = document.querySelectorAll('.custom-swatches-vernis');
    if (!customSwatchesVernisElements) return;

    const locale = window.Shopify.locale.toUpperCase();
    const customSwatchesVernisCollections = [...new Set(Array.from(customSwatchesVernisElements).map(div => div.dataset.collection).filter(Boolean))];
    async function fetchCollectionData(collectionId) {
      const query = `
        query customSwatchesVernisCollections @inContext(language: ${locale}) {
          collection(id: "gid://shopify/Collection/${collectionId}") {
            title
            products(first: 250) {
              edges {
                node {
                  title
                  handle
                  metaColorLabel: metafield(namespace: "custom", key: "couleur_libelle") { value }
                  metaColorHexa: metafield(namespace: "custom", key: "couleur_code_hexa") { value }
                }
              }
            }
          }
        }
      `;

      const response = await fetch('/api/2023-10/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': '9ff8f07598c4c8766887953c66ec243e'
        },
        body: JSON.stringify({ query })
      });

      const result = await response.json();
      return result.data.collection;
    }

    async function customSwatchesVernisLoadAll() {
      for (const collectionId of customSwatchesVernisCollections) {
        try {
          const collection = await fetchCollectionData(collectionId);
          const products = collection.products.edges.map(edge => edge.node);
          
          const html = products.map((p, i) => {
            if (i < 5) {
              const colorHex = p.metafield?.find(m => m.key === "couleur_code_hexa")?.value || p.metaColorHexa?.value || "#e5e5e5";
              const colorLabel = p.metafield?.find(m => m.key === "couleur_libelle")?.value || p.metaColorLabel?.value || '';
              const productUrl = `/products/${p.handle}`;
              const selectedClass = (isLightColor(colorHex, 225) ? ' light-color' : '');

              return `
                <div class="swatch__button">
                  <div class="swatch__label${selectedClass}" ${colorLabel ? `data-tooltip="${colorLabel}"` : ""} data-color="${colorHex}" style="--swatch: ${colorHex}">
                    <a href="${productUrl}" class="swatch__link">${colorLabel}</a>
                  </div>
                </div>
              `;
            }
          }).join('');

          const customSwatchesVernisElementsUpdate = document.querySelectorAll('.custom-swatches-vernis[data-collection="' + collectionId + '"]');
          customSwatchesVernisElementsUpdate.forEach(elem => {
            elem.innerHTML = html + (products.length > 5 ? '<span class="swatch__text-more-2">+ ' + (products.length - 5) + '</span>' : '');
          });

        } catch (err) {
          console.error(`Erreur sur la collection ${collectionId}`, err);
        }
      }
    }

    customSwatchesVernisLoadAll();
  });

  // VARIANTS CHECK SWATCHES COLOR
  setTimeout(function(){
    document.querySelectorAll(".swatch__label.check-light").forEach(swatch => {
      const color = getComputedStyle(swatch).getPropertyValue('--swatch').trim();
      if (color) {
        if (isLightColor(color, 225)) {
          swatch.classList.add('light-color');
        }
      }
    });
  }, 250);
})();

function isLightColor(color, limit = 186) {
  let r, g, b;

  if (color.startsWith('#')) {
    let hex = color.replace('#', '');

    if (hex.length === 3) {
      hex = hex.split('').map(c => c + c).join('');
    }

    r = parseInt(hex.substring(0, 2), 16);
    g = parseInt(hex.substring(2, 4), 16);
    b = parseInt(hex.substring(4, 6), 16);
  }
  else if (color.startsWith('rgb')) {
    [r, g, b] = color.match(/\d+/g).map(Number);
  }
  else {
    return null;
  }

  const luminance = (0.299 * r + 0.587 * g + 0.114 * b);

  return luminance > limit;
}

// FILTERS FAKE CLICK COLOR
function FiltersFakeClickColor() {
  const colorFilterChecked = document.querySelectorAll('.filter__input.swatch__input:checked');
  colorFilterChecked.forEach(colorFilter => {
    const swatches = document.querySelectorAll(`.product-grid-item .swatch__button[data-value2="${colorFilter.value}"]`);
    if (swatches) {
      swatches.forEach(swatch => {
        const label = swatch.querySelector('.swatch__label');
        const variantId = label.dataset.swatchVariant;
        const cardElement = swatch.closest('.product-grid-item');
        const cardImage = cardElement.querySelector('.product__media__image > .product__media');
        const cardImageTemplate = cardElement.querySelector('.product__media__image > template');
        const cardImageVariant = cardImageTemplate.content.querySelector('.product__media[data-variant-id="' + variantId + '"]');
        cardImage.innerHTML = cardImageVariant.innerHTML;
      });
    }
  });
}

// CUSTOM WEGLOT SELECT
/*function waitForWeglot() {
  if (window.Weglot) {
    WeGlotCreateHeaderSelect();
  } else {
    setTimeout(waitForWeglot, 50);
  }
}
waitForWeglot();

function WeGlotCreateHeaderSelect() {
  var sHtml, lang, text, myClass;

  var myTarget = document.getElementById("lang-switch-target");
  var myTargetList = myTarget.querySelector("ul");
  
  var availableLanguages = weglot_lang.split(','); //Weglot.options.languages.map(function(language) { return language.language_to; }).concat(Weglot.options.language_from);
  var currentLang = Weglot.getCurrentLang();
  
  for (var i = 0; i < availableLanguages.length; i++) {
    lang = availableLanguages[i];
    text = lang.toUpperCase();;
    myClass = '';

    if (lang == currentLang)
      myClass = 'select-popout__item--current';
    
    sHtml = `<li class="select-popout__item ${myClass}"><a href="#" class="select-popout__option" data-lang="${lang}" data-wg-notranslate>${text}</a></li>`;
    
    myTargetList.innerHTML += sHtml;
  }

  var myTargetBtn = document.querySelectorAll("#lang-switch-target ul li a");
  myTargetBtn.forEach(bt => {
    bt.addEventListener("click", (event) => {
      event.preventDefault();
      let lang = bt.dataset.lang;
      Weglot.switchTo(lang);
    });
  });
}*/